export const emails = {
    contact: 'contacto@ifiesta.com.mx',
    hosts: 'anfitriones@ifiesta.com.mx',
}

export const phoneNumbers = {
    contact: '5633238133',
    contactFormatted: '52 56 3323 8133',
    generalFormatted: '55 2772 7402'
}